import { IRole, IPermission } from "models/church.types";
import api from "./api";
import { environnement } from "configs/environnement";

const RoleService = {
  getAll: () => {
    return api.get<IRole[]>(`${environnement.baseURL}/authorities`);
  },

  getById: (id: string) => {
    return api.get<IRole>(`${environnement.baseURL}/authorities/${id}`);
  },

  // Ici, le paramètre 'role' contient déjà la liste des objets IPermission complets
  create: (role: IRole) => {
    return api.post<IRole>(`${environnement.baseURL}/authorities`, role);
  },

  update: (role: IRole) => {
    return api.put<IRole>(`${environnement.baseURL}/authorities`, role);
  },

  delete: (id: string) => {
    return api.delete(`${environnement.baseURL}/authorities/${id}`);
  },

  getAllPermissions: () => {
    return api.get<IPermission[]>(`${environnement.baseURL}/permissions`);
  },
};

export default RoleService;
